module.exports = __webpack_public_path__ + "img/crashed-car.9dee9751.svg";